import React from 'react'
import './Form.css'

export const Form = props => (
    <div className="Form">
        <form {...props}>
            {props.children}
        </form>
    </div>
)

export const FormRow = props => (
    <div className="FormRow">
        {props.children}
    </div>
)

export const Select = props => (
    <div className="Select">
        <select onChange={props.onChange} value={props.value}>
            <SelectOption value="default" label={props.placeholder} />
            {props.list.map((item, idx) => (
                <SelectOption value={item.value} label={item.label} key={idx} />
            ))}
        </select>
    </div>
)

export const SelectOption = props => (
    <option value={props.value}>{props.label}</option>
)

export const Input = props => (
    <div className="Input">
        <input {...props} />
    </div>
)

export const Button = props => (
    <div className="Button">
        <button type="submit" onClick={props.onClick}>{props.label}</button>
    </div>
)


// WEBPACK FOOTER //
// ./src/components/common/Form.js